module.exports = __webpack_public_path__ + "static/media/rodo-w-marketingu-cover-pl.6f27f683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/rodo-w-marketingu-cover-pl.png
// module id = 557
// module chunks = 0